// @flow

// Operator State
import { initialState as operatorState } from 'hfty-operator-orders'

export default {
  ...operatorState,
}
